export function formatTime(inputTime: string) {
    const time = inputTime
    const formattedTime = time.slice(0, 5)
    return formattedTime
}

export function getDayOfWeek(dayNumber: number): string {
    const daysOfWeek = [
        "Sunday",    // Index 0, corresponds to 1
        "Monday",    // Index 1, corresponds to 2
        "Tuesday",   // Index 2, corresponds to 3
        "Wednesday", // Index 3, corresponds to 4
        "Thursday",  // Index 4, corresponds to 5
        "Friday",    // Index 5, corresponds to 6
        "Saturday"   // Index 6, corresponds to 7
    ]

    if (dayNumber < 1 || dayNumber > 7) {
        return "Invalidate Day"
    }

    return daysOfWeek[dayNumber - 1]
}

export const format12HourTime = (timeStr: string): string => {
    const [hour, minute] = timeStr.split(':').map(Number)
    const date = new Date()
    date.setHours(hour, minute)
    return date.toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    }) // Format to 12-hour time
}

export const formatDay = (fullDay: string): string => {
    return fullDay.slice(0, 3) // Return first three letters of the day
}

export const getCurrentDate = (): string => {
    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, "0")
    const day = String(today.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
}

export function formatTimeSlotList(slots: { day: string; start_time: string; end_time: string }[]){
    const format12Hour = (time: string): string => {
        const [hour, minute] = time.split(":").map(Number)
        const date = new Date()
        date.setHours(hour, minute)
        return date.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        })
    }

    const shortDay = (day: string): string => {
        return day.slice(0, 3)
    }

    return slots
        .map(slot => {
            const start = format12Hour(slot.start_time)
            const end = format12Hour(slot.end_time)
            return `${start} - ${end} ${shortDay(slot.day)}`
        }).join(", ")
}

// Helper function to determine if a color is dark
export const isColorDark = (hexColor: string): boolean => {
    // Remove # if present
    const hex = hexColor.replace('#', '')
        
    // Convert hex to RGB
    const r = parseInt(hex.substr(0, 2), 16)
    const g = parseInt(hex.substr(2, 2), 16)
    const b = parseInt(hex.substr(4, 2), 16)
    
    // Calculate luminance using the relative luminance formula
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255
    
    // Return true if color is dark (luminance < 0.5)
    return luminance < 0.5
}

// Helper function to extract YouTube video ID from URL
export const extractYouTubeId = (url: string): string => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
    const match = url.match(regExp)
    return (match && match[2].length === 11) ? match[2] : ''
}